import React, { useState } from "react";
import ApprovalBallotView from "./ApprovalBallotView";

export default function ApprovalBallot({
  race,
  candidates,
  onUpdate,
  defaultRankings,
  readonly
}) {
  const [rankings, setRankings] = useState(
    defaultRankings ? defaultRankings : Array(candidates.length).fill(0)
  );
  console.log("default", defaultRankings);
  return (
    <ApprovalBallotView
      key="approvalBallot"
      race={race}
      candidates={candidates}
      rankings={rankings}
      onClick={(i, j) => {
        console.log(`${candidates[i].candidate} = ${j}`);
        const newRankings = [...rankings];
        newRankings[i] = newRankings[i] === j ? 0 : j;
        setRankings(newRankings);
        onUpdate(newRankings);
      }}
      readonly={readonly}
    />
  );
}
